<template>
	<v-container grid-list-xl>
		<v-form v-model="isEditValid">
			<v-layout row wrap>
				<v-flex lg6>
					<v-switch label="Active" v-model="objRoleEdit.active"></v-switch>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Role Name:</label>
					<v-text-field label="Name" v-model="objRoleEdit.name" :rules="nameRules" required single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Role Description:</label>
					<v-text-field label="Description" v-model="objRoleEdit.description" :rules="descriptionRules" required single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Role User Type:</label>
					<v-select :items="userType" label="User Type" class="dropdown" v-model="objRoleEdit.user_type" :rules="userRules" required item-value="id" single-line solo></v-select>
				</v-flex>
        <v-flex lg6 v-show="objRoleEdit.user_type == '1'">
          <label class="blackLabel">* Is Role Commercial Role:</label>
          <v-switch v-model="objRoleEdit.is_commercial_kam"></v-switch>
        </v-flex>
        <!--<v-flex lg6>
          <label class="blackLabel">* Is Role Commercial Originator Role:</label>
          <v-switch v-model="objRoleEdit.is_commercial_originator"></v-switch>
        </v-flex>-->
				<div class="pl-4 pr-4 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isEditValid" @click.stop="fncEditRole()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				roleActive: false,
				isEditValid: false,
				userType: [
					{ id: 1, text: 'Manufacturer User' },
					{ id: 2, text: 'Customer User' },
					{ id: 3, text: 'Specifier User' },
					{ id: 4, text: 'Public User' },
                    { id: 5, text: 'Non-registered User' },
                    { id: 6, text: 'Vendor User' }
				],
				nameRules: [
					v => !!v || 'Role name is required',
				],
				descriptionRules: [
					v => !!v || 'Role description is required',
				],
				levelRules: [
					v => !!v || 'Role level is required',
				],
				userRules: [
					v => !!v || 'Role user type is required',
				]
			};
		},
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncEditRole() {
			  if( this.objRoleEdit.is_commercial_kam == true ) {
          this.objRoleEdit.is_commercial_kam = 1;
        } else {
          this.objRoleEdit.is_commercial_kam = 0;
        }
        if( this.objRoleEdit.is_commercial_originator == true ) {
          this.objRoleEdit.is_commercial_originator = 1;
        } else {
          this.objRoleEdit.is_commercial_originator = 0;
        }
				this.$store.dispatch({
					type: 'fncEditRole',
					role: this.objRoleEdit
				});
			}
		},
    mounted() {
	    if( this.objRoleEdit.is_commercial_originator == '0' || this.objRoleEdit.is_commercial_originator == 0 ) {
        this.objRoleEdit.is_commercial_originator = false;
      } else {
        this.objRoleEdit.is_commercial_originator = true;
      }
      if( this.objRoleEdit.is_commercial_kam == '0' || this.objRoleEdit.is_commercial_kam == 0 ) {
        this.objRoleEdit.is_commercial_kam = false;
      } else {
        this.objRoleEdit.is_commercial_kam = true;
      }
    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
				'objRoleEdit'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
